import styled from "styled-components";

export const Button = styled.div`
	position: fixed;
	right: 40px;
	bottom: 80px;
	height: 20px;
	font-size: 3rem;
	z-index: 1000;
	cursor: pointer;
	color: #fff;
`;